import React from 'react'
import PropTypes from 'prop-types'

import GetStartedPackageLayout from './get-started-package-layout'
import GetStartedPackageHeader from './get-started-package-header'
import GetStartedPackageList from './get-started-package-list'
import GetStartedPackageButton from './get-started-package-button'

const GetStartedPackage = ({ free, premium, custom, mainColor }) => {
  if (free) {
    const listData = [
      'LAUNCH WORKSHOP',
      'Voting, casting & judge rating tools',
      'Embed content on your website',
      'Earn revenue with paid votes & sponsors',
      'Work as a team, add multiple team members',
      'Create rich contestant profiles',
      'Increase engagement & social sharing',
      'Revenue share: Beauty pageant 50% / 50% Next Miss'
    ]

    return (
      <GetStartedPackageLayout recommended>
        <GetStartedPackageHeader
          plan="Premium plan"
          price="Free"
          priceAbout="+ earn revenue with paid votes & sponsors"
          revenue="50% (YOU) / 50% REVENUE SHARE"
          color={mainColor}
        />

        <GetStartedPackageList
          title="Premium Plan includes"
          subtitle="All these great features:"
          data={listData}
        />

        <GetStartedPackageButton
          text="Get started"
          color={mainColor}
          url="https://admin.choicely.com/brand/create"
        />
      </GetStartedPackageLayout>
    )
  }

  if (custom) {
    const listData = [
      'We develop your own beauty app',
      'High volume traffic management ',
      'Dedicated account manager',
      'Advanced analytics',
      'Custom feature development',
      'Custom integrations',
      'Gold Support',
      'Revenue share: To be negotiated'
    ]

    return (
      <GetStartedPackageLayout>
        <GetStartedPackageHeader
          plan="Gold plan"
          price="Custom"
          priceAbout="based on volume & number of shows"
          color={mainColor}
        />

        <GetStartedPackageList
          title="Gold Plan includes"
          subtitle="These optional services:"
          data={listData}
        />

        <GetStartedPackageButton
          text="Contact us"
          color={mainColor}
          url="https://calendly.com/choicely"
        />
      </GetStartedPackageLayout>
    )
  }

  return null
}

GetStartedPackage.propTypes = {
  free: PropTypes.bool
}

export default GetStartedPackage



// WEBPACK FOOTER //
// ./src/components/get-started-package/get-started-package.js